import React, { useState, useEffect } from 'react';
import { Zap, Battery } from 'lucide-react';
import banner1 from "../assests/image 82.png"; // Fixed: "assets" not "assests"
import banner2 from "../assests/banner2.png"
import banner3 from "../assests/banner3.png"
import banner4 from "../assests/banner4.png"
import banner5 from "../assests/banner5.png"
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  
  const handleclick = () => {
    navigate('/Products');
  }
  
  // Carousel content
  const slides = [
    {
      id: 1,
      headline: "Trusted Power Electronics Partner for OEMs Across Industries",
      subheadline: "With 35+ years of expertise, Vidyut Systems delivers custom-designed power electronics, control systems, and PCB solutions for solar, defence, mobility, and industrial automation.",
      keywords: "power electronics manufacturer, OEM electronics India, control systems, industrial PCB design, trusted electronics partner",
      bgImage: banner1
    },
    {
      id: 2,
      headline: "Advanced Battery Systems & BESS Solutions Backed by Deep Domain Knowledge",
      subheadline: "From lithium-ion battery packs to utility-scale Battery Energy Storage Systems (BESS), Vidyut brings engineering precision, thermal expertise, and reliability to every power storage solution.",
      keywords: "battery systems manufacturer India, BESS provider, lithium-ion battery solutions, energy storage systems for industry",
      bgImage: banner2
    },
    {
      id: 3,
      headline: "Precision Electronics for Electric Mobility and UAV Platforms",
      subheadline: "Vidyut's proven capabilities in EV control units, drone electronics, and smart battery integration make us a preferred partner for electric vehicle and aerospace OEMs.",
      keywords: "EV electronics India, drone PCB design, electric vehicle control systems, UAV battery packs, automotive electronics OEM",
      bgImage: banner3
    },
    {
      id: 4,
      headline: "Solar Inverter and Control Solutions for Homes and Utility Projects",
      subheadline: "With field-proven solar electronics used in rooftop systems and multi-megawatt solar farms, Vidyut is the go-to engineering partner for reliable and scalable solar deployments.",
      keywords: "solar inverter PCB manufacturer, solar control panel India, solar electronics partner, rooftop solar systems, utility solar plant electronics",
      bgImage: banner4
    },
    {
      id: 5,
      headline: "India's Trusted Power Electronics Partner for Global OEMs",
      subheadline: "Built on decades of trust, Vidyut enables international OEMs with high-quality electronics, deep application knowledge, and scalable manufacturing partnerships.",
      keywords: "Indian electronics OEM, global electronics partner, export-ready PCB manufacturer, reliable power electronics company India",
      bgImage: banner5
    }
  ];

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // Change slide every 5 seconds

    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlideData = slides[currentSlide];
  
  return (
<section className="relative w-full h-[70vh] md:h-[100vh] overflow-hidden transition-all duration-1000 ease-in-out">
  {/* Full image */}
  <img 
    src={currentSlideData.bgImage}
    alt={currentSlideData.headline}
    className="absolute inset-0 w-full h-full object-fill transition-all duration-1000 ease-in-out"
  />

      {/* Overlay for better text readability */}
      <div className="absolute inset-0 "></div>

      {/* Hero Content */}
      <div className="relative z-10 flex items-center justify-start h-full px-4 sm:px-6 md:pl-12 lg:pl-24 md:pr-12 lg:pr-24 py-8 md:py-12">
        <div className="text-left text-white w-full max-w-5xl">
          <h1 className="text-2xl sm:text-3xl pt-6 md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4 md:mb-6 leading-tight transition-all duration-500 ease-in-out">
            {currentSlideData.headline}
          </h1>
          
          <p className="text-sm sm:text-base md:text-lg lg:text-lg mb-6 md:mb-8 max-w-full md:max-w-lg opacity-90 transition-all duration-500 ease-in-out leading-relaxed">
            {currentSlideData.subheadline}
          </p>
          
          <button 
            onClick={handleclick} 
            className="bg-[#0572AF] hover:bg-blue-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 w-full sm:w-auto"
          >
            Explore Our Products →
          </button>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 z-20">
        <div className="flex space-x-2 md:space-x-3">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 md:w-3 md:h-3 rounded-full transition-all duration-300 ${
                currentSlide === index 
                  ? 'bg-white scale-125' 
                  : 'bg-white/50 hover:bg-white/75'
              }`}
            />
          ))}
        </div>
      </div>

      {/* Keywords overlay (hidden but good for SEO) */}
      <div className="sr-only">
        {currentSlideData.keywords}
      </div>
    </section>
  );
};

export default HeroSection;